import React from "react";
import styles1 from "../../styles/components/partnerSubmissionFeeModal.module.scss";
import assest from "../../json/assest";
import { Button } from "@imarabinda/antd";
import {
  MenuItem,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import CustomSelectTwo from "../CustomSelectTwo/CustomSelectTwo";
import { getEarningStatus, getYearRange } from "../../lib/functions/utils.lib";
import HtmlToPdfConverter from "../HtmlToPdfConverter/HtmlToPDfConveter";
// import Image from "next/image";

function createData(Month, Amount, PaymentStatus) {
  return { Month, Amount, PaymentStatus };
}

const rows = [
  createData("January", "$1025", "Completed"),
  createData("February", "$1025", "Completed"),
  createData("March", "$1025", "Completed"),
  createData("April", "$1025", "Completed"),
  createData("May", "$1025", "Completed"),
  createData("June", "$1025", "Completed"),
];

// interface AnalyticsBreakdownProps {
//     earnings ;
// }

const AnalyticsBreakdown = ({ earnings, setEarningSummaryYear }) => {
  const yearRange = getYearRange();
  const [status, setStatus] = React.useState(yearRange[0].value);
  // console.warn(Object.keys(earnings));

  const handleChange1 = (event) => {
    setStatus(event.target.value);
    setEarningSummaryYear(event.target.value);
  };

  return (
    <Box className={styles1.analyticsBreakdown}>
      <Box className={styles1.analyticsBreakdownBody}>
        <h4>Earnings breakdown</h4>
        <Box className={styles1.analysticYearSelect}>
          <CustomSelectTwo value={status} onChange={handleChange1} displayEmpty>
            {yearRange.map((item, index) => {
              return (
                <MenuItem key={index} value={item?.value}>
                  {item?.year}
                </MenuItem>
              );
            })}
          </CustomSelectTwo>
        </Box>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          className={styles1.breakDownRow}
        >
          <Box className={styles1.breakdownTableItem}>
            <Box className={styles1.breakdownTableBox}>
              <Box className={styles1.analyticsBreakdownHeader}>
                <Button>January - June</Button>
              </Box>
              <Box className={styles1.analyticsBreakdownTable}>
                <TableContainer>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell className={styles1.month}>Month</TableCell>
                        <TableCell className={styles1.amount}>Amount</TableCell>
                        <TableCell className={styles1.payment}>
                          Payment Status
                        </TableCell>
                        <TableCell className={styles1.download}>
                          Download Report
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {earnings
                        ? Object.keys(earnings)
                            .slice(0, 6)
                            .map((row, index) => {
                              const earningStatus = getEarningStatus(row);
                              return (
                                <TableRow key={row}>
                                  <TableCell>{row}</TableCell>
                                  <TableCell>
                                    {earningStatus >= 0
                                      ? earnings[row]
                                        ? "$" + earnings[row]
                                        : "-"
                                      : "-"}
                                  </TableCell>
                                  <TableCell>
                                    {earningStatus === 0
                                      ? "Pending"
                                      : earningStatus === 1
                                      ? "Completed"
                                      : "-"}
                                  </TableCell>
                                  <TableCell>
                                    {earningStatus >= 0 ? (
                                      <Button>
                                        {/* <img
                                      src={assest.downloadReportIcon}
                                      width={17}
                                      height={15}
                                      alt=""
                                    /> */}
                                        <HtmlToPdfConverter />
                                      </Button>
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                        : ""}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </Box>

          <Box className={styles1.breakdownTableItem}>
            <Box className={styles1.breakdownTableBox}>
              <Box className={styles1.analyticsBreakdownHeader}>
                <Button>July - December</Button>
              </Box>
              <Box className={styles1.analyticsBreakdownTable}>
                <TableContainer>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell className={styles1.month}>Month</TableCell>
                        <TableCell className={styles1.amount}>Amount</TableCell>
                        <TableCell className={styles1.payment}>
                          Payment Status
                        </TableCell>
                        <TableCell className={styles1.download}>
                          Download Report
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {earnings
                        ? Object.keys(earnings)
                            .slice(6)
                            .map((row) => {
                              const earningStatus = getEarningStatus(row);
                              return (
                                <TableRow key={row}>
                                  <TableCell>{row}</TableCell>
                                  <TableCell>
                                    {earningStatus >= 0
                                      ? earnings[row]
                                        ? "$" + earnings[row]
                                        : "-"
                                      : "-"}
                                  </TableCell>
                                  <TableCell>
                                    {earningStatus === 0
                                      ? "Pending"
                                      : earningStatus === 1
                                      ? "Completed"
                                      : "-"}
                                  </TableCell>
                                  <TableCell>
                                    {earningStatus >= 0 ? (
                                      <Button>
                                        {/* <img
                                        src={assest.downloadReportIcon}
                                        width={17}
                                        height={15}
                                        alt=""
                                      /> */}
                                        <HtmlToPdfConverter />
                                      </Button>
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                        : ""}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default AnalyticsBreakdown;
